var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpchevron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.848 12.2076L8 5.05556L15.152 12.2076C15.248 12.3036 15.3653 12.3516 15.504 12.3516C15.6427 12.3516 15.76 12.3036 15.856 12.2076C15.952 12.1116 16 11.9942 16 11.8556C16 11.7169 15.952 11.5996 15.856 11.5036L8 3.64756L0.143999 11.5036C0.0480003 11.5996 0 11.7169 0 11.8556C0 11.9942 0.0480003 12.1116 0.143999 12.2076C0.24 12.3036 0.357332 12.3516 0.495999 12.3516C0.634666 12.3516 0.751999 12.3036 0.848 12.2076Z",
    fill: "content"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpchevron);
export default __webpack_public_path__ + "static/media/upchevron.8b57e12eafdbceb94c4f8a55d425506b.svg";
export { ForwardRef as ReactComponent };